import type { GetBusinessTraitsHelper_BusinessFragment } from './getBusinessTraits.graphql'
import type { Counters } from 'gql/types'

export const getBusinessTraits = ({
  id,
  address,
  officialName,
  subscription,
  roles,
  kybStatus,
  businessStructure,
  industry,
  counters,
}: GetBusinessTraitsHelper_BusinessFragment & { counters?: Pick<Counters, 'all' | 'receivableInvoices'> }) => ({
  businessId: id,
  businessName: officialName,
  country: address?.country,
  businessPlan: subscription?.plan.name,
  businessRoles: roles,
  businessKybStatus: kybStatus,
  businessStructure,
  businessIndustry: industry,
  payableInvoicesCount: counters?.all,
  receivableInvoicesCount: counters?.receivableInvoices,
})
